// global.$ = global.jQuery = require('jquery');
import { createApp } from 'vue'
import mitt from 'mitt'
import ProcessMapView from '@vueapp/views/ProcessMapView.vue'

// import VueTippy from 'vue-tippy'

export class ProcessMap {

	constructor( elements ) {
        let _this = this

        if ( elements.length ) {
            elements.forEach(function (item, key) {
            	const emitter = mitt()
				const app = createApp(ProcessMapView, {
					postId: item.getAttribute('data-post-id'),
					postSlug: item.getAttribute('data-post-slug')
				})
				app.config.globalProperties.emitter = emitter
				app.mount('#' + item.getAttribute('id') )    

            })
        }

	}
	

}